import { api } from "../api";
import { createBrowserHistory } from "history";

export const logout = function() {
  localStorage.removeItem("user");
  localStorage.removeItem("geo");

  let url = '/';

  /*let ecommerce = localStorage.getItem("ecommerce");
  if(ecommerce !== 'centrofarma') {
    url = '/';
  } else {
    url = '/login/centrofarma'
  }

  localStorage.removeItem("ecommerce");*/

  createBrowserHistory({ forceRefresh: true }).push(url);
};

export const login = function(email, password, ecommerce, callback) {
  const URL = "/authenticate";
  let data = {
    email,
    password,
  };
  
  if(email.includes("@")){
    api
      .post(URL, data)
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("company", response.data.company);
        localStorage.setItem("ecommerce", ecommerce);
        api.defaults.headers.authorization = `Bearer ${response.data.token}`;
        callback(response.data.token);
      })
      .catch((error) => {
        callback("");
      });
  }
  else{
    
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjUyYzgxYmZmLWE5ZDMtNDRiYi04MTZlLWZkMmE2OGVhYTA5ZCIsIm5hbWUiOiJmYWJyaWthIiwiZW1haWwiOiJmYWJyaWthQGZhYnJpa2EuY29tLmJyIiwicm9sZUlkIjoiYTA4ZDdmOWQtMWM3OS00YWI1LWE1ZGQtNWUwMzUyYzJkZmU2IiwiaWF0IjoxNjA2MjUwNzk5LCJleHAiOjE5MjE2MTA3OTl9.cfAfK9TI9JIzizT-pDgnDlWq4qSUrIP8zBhtzbOPYqQ";
    let config = {
      headers:{
        authorization: `Bearer ${token}`
      }
    }

    data = {
      usuario: data.email,
      senha: data.password,
      acao: 'AUTORIZA'
    };
    api.defaults.headers.authorization = `Bearer ${token}`;  
    api
      .post('/lockers/correios/usuarios', data, config)
      .then((response) => {
        const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjUyYzgxYmZmLWE5ZDMtNDRiYi04MTZlLWZkMmE2OGVhYTA5ZCIsIm5hbWUiOiJmYWJyaWthIiwiZW1haWwiOiJmYWJyaWthQGZhYnJpa2EuY29tLmJyIiwicm9sZUlkIjoiYTA4ZDdmOWQtMWM3OS00YWI1LWE1ZGQtNWUwMzUyYzJkZmU2IiwiaWF0IjoxNjA2MjUwNzk5LCJleHAiOjE5MjE2MTA3OTl9.cfAfK9TI9JIzizT-pDgnDlWq4qSUrIP8zBhtzbOPYqQ";    
        let user = response.data;
        user.token = token;
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("company", "correios")//response.data.company);
        
        callback(token);
      })
      .catch((error) => {
        
        callback("");
      });
  }
}
